import { Box, Grid } from '@material-ui/core';
import Menu from '@material-ui/icons/Menu';
import React from 'react';
import { BaseButton } from 'src/common/components/base-button';
import { CashierPreferences } from 'src/common/interfaces/dtos/CashierPreferences';
import { styles } from './styles';

interface MenuButtonProps {
  onClick: () => void;
  cashierPreferences: CashierPreferences;
  trainingModeActive: boolean;
}

const MenuButton: React.FC<MenuButtonProps> = ({
  onClick,
  cashierPreferences,
  trainingModeActive,
}): JSX.Element => {
  const classes = styles({
    textSize: cashierPreferences?.textZoomLevel,
    leftHanded: cashierPreferences?.leftHanded,
    trainingModeActive,
  });

  const handleClick = (event: React.MouseEvent<HTMLElement, MouseEvent>): void => {
    event.preventDefault();
    onClick();
  };

  return (
    <Box className={classes.menuButtonWrapper}>
      <BaseButton
        onClick={event => {
          handleClick(event);
        }}
        className={classes.menuButton}
        disableRipple
        data-testid='top-area-button-menu'
      >
        <Grid container alignItems='center' wrap='nowrap'>
          <Menu className={`icon ${classes.iconStyle}`} />
        </Grid>
      </BaseButton>
    </Box>
  );
};

export default MenuButton;
